<template>
  <div class="ejpagination-pages fr" v-if="list.length>0 ">
      <span class="page-first"  @click="postPage(1)">首页</span>
      <span class="page-first"  @click="prevPage()" v-if="PageIndex>1">上一页</span>
      <span :class="(PageIndex==item.value?'current active':'')" v-for="(item,item_index) in list" :key="item_index" @click="selectPage(item.value)">{{item.name}}</span>
      <span class="page_next" v-if="PageIndex!=list[list.length-1].value" @click="nextPage()">下一页</span>
      <span class="page_next" @click="postPage(list[list.length-1].value)">尾页</span>
  		<span class="page_next">共{{pageNum}}页</span>
  </div>
</template>
<!--
 <div class="table-pager" v-if="list.length>0 ">
  	<div class="p-prev"  @click="prevPage()" v-if="PageIndex>1"><span></span></div>
  	<div class="p-prev p-hui" v-else><span></span></div>
    <div :class="'p-item '+(PageIndex==item.value?'on':'')" v-for="(item,item_index) in list" :key="item_index" @click="selectPage(item.value)">{{item.name}}</div>
  	<div class="p-next" v-if="PageIndex!=list[list.length-1].value" @click="nextPage()"><span></span></div>
    <div class="p-next p-hui" v-else><span></span></div>
  </div>
-->
<script>
  export default {
    props: ['PageSize','Total','PageIndex'],
    data() {
      return {
        list:[],
        v_index: 1,//输入页码
        pageNum:0//总页数
      }
    },
    watch: {
      Total(nVal){
        this.initPager();
      },
      PageIndex(nVal){
        this.initPager();
      },
      PageSize(nVal){
        this.initPager();
        this.$emit('SetPageIndex',1);
      }
    },
    mounted() {
      this.initPager();
    },
    methods: {
      //初始化控件
      initPager(){
        let pageNum = (this.Total - this.Total % this.PageSize) / this.PageSize;
        if (this.Total % this.PageSize > 0) pageNum += 1;
        this.pageNum = pageNum;
        let list = [];
        let length = pageNum > 5 ? 5 : pageNum;
        let min = 0;
        let max = length;
        this.v_index = this.PageIndex;
        if (this.PageIndex > 5) {
        	min = this.PageIndex - 5;
        	max = min + length;
        }
        if(min>0){
          list.push({
          	name: '1',
          	value: 1,
          	type: 1
          });
        }
        if(min>1){
          list.push({
          	name: '...',
          	value: min,
          	type: 2
          });
        }
        for (let i = min; i < max; i++) {
        	list.push({
        		name: i + 1,
        		value: i + 1,
        		type: 1
        	})
        }

        if (pageNum > 6) {
        	if (this.PageIndex < pageNum - 1) {
        		list.push({
        			name: '...',
        			value: max + 1,
        			type: 2
        		});
        		list.push({
        			name: pageNum,
        			value: pageNum,
        			type: 3
        		})
        	}
        	if (this.PageIndex == pageNum - 1) {
        		list.push({
        			name: pageNum,
        			value: pageNum,
        			type: 3
        		})
        	}
        } else {

        	if (list.length>0 && pageNum !=list[list.length-1].value) {
        		list.push({
        			name: pageNum,
        			value: pageNum,
        			type: 3
        		})
        	}

        }

        this.list = list;
      },
      //选择页
      selectPage(item){
        this.$emit('SetPageIndex',item)
      },
      //选择每页显示条数
      selectPageSize(obj){
        this.$emit('SetPageSize',obj.target.value);
      },
      //上一页
      prevPage() {
      	if (this.PageIndex == 1) return;
        this.$emit('SetPageIndex',this.PageIndex-1);
      },
      //下一页
      nextPage() {
      	if (this.PageIndex == this.pageNum) return;
      	this.$emit('SetPageIndex',this.PageIndex+1);
      },
      postPage(index){
        this.$emit('SetPageIndex',index);
      },
      //确定跳页
			tzPage() {
				if (this.v_index < 1) {
					this.v_index = 1;
				}
				if (this.v_index > this.pageNum) {
					this.v_index = this.pageNum;
				}
				this.$emit('SetPageIndex',this.v_index);
			}
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/assemblys/Pager.vue